import { itx } from "../../../src/translationItx/itx";
export function c1PdfFileName(projectName: string, date = new Date()): string {
  const safeProjectName = projectName.replace(/[<>:"/\\|?*]+/g, "_").trim() || itx("cover.project", "Projekt");
  const datePostfix = [date.getDate(), date.getMonth() + 1, date.getFullYear()]
    .map((part, index) => (index < 2 ? String(part).padStart(2, "0") : String(part)))
    .join("_");
  return `${safeProjectName}_${datePostfix}.pdf`;
}
